import { Component } from '@angular/core';
import {Router} from "@angular/router";

@Component({
    selector: 'brightside-web-savings-autosave-intro',
    templateUrl: './savings-autosave-intro.component.html',
    styleUrls: ['./savings-autosave-intro.component.css'],
    standalone: false
})
export class SavingsAutosaveIntroComponent {

  constructor(
    private router: Router
  ) { }

  goToAutoSave() {
    this.router.navigate(['accounts', 'savings', 'creation', 'autosave']);
  }

  goToDashboard() {
    this.router.navigate(['accounts', 'savings', 'dashboard']);
  }
}
